import { render, staticRenderFns } from "./KullaniciDashboard.vue?vue&type=template&id=9c16df12"
import script from "./KullaniciDashboard.vue?vue&type=script&lang=js"
export * from "./KullaniciDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports